import React, { useState } from 'react';
import Header from '../Header/Header';
import "./Banner.css";
import hero from '../../images/Anis Ayser.jpg';
import Typewriter from 'typewriter-effect';
import loader from "../../images/Ripple-2s-200px (1).svg";
import resume from "../../images/resume.png";



const Banner = () => {




    return (
        <div id='home'>
            <div className="tilt-bg  h-screen">

                <div className='w-full h-[70px]'></div>
                <div className="container mx-auto h-full">
                    <div className="grid grid-cols-8 gap-0 lg:gap-12 h-full">

                        <div className="col-span-8"></div>
                        <div className='hidden lg:block'></div>

                        <div className="flex justify-center sm:items-center col-span-8 md:col-span-3 w-full mb-0">
                            {hero && <div data-aos="fade-right" className='bg-gradient-to-r from-neutral-content rounded-full p-2 w-40 h-40 md:w-64 md:h-64 xl:w-80 xl:h-80'>
                                <img src={hero} className="w-full h-full rounded-full" alt="" />
                                {/* <img src={loader} alt="" /> */}
                            </div>}
                        </div>

                        <div className="flex sm:items-center justify-center md:justify-start col-span-8 md:col-span-4">
                            <div data-aos="fade-left" className='text-center'>
                                <span className="text-4xl sm:text-6xl mx-auto color-font">
                                    I Am Anis Ayser
                                </span>
                                <span className='text-netural-content text-2xl sm:text-4xl uppercase'>
                                    <Typewriter
                                        skipAddStyles={false}
                                        options={{
                                            strings: ['Programmer', 'Web Developer', 'Website Designer'],
                                            autoStart: true,
                                            loop: true,
                                        }}
                                    />
                                </span>

                            </div>
                        </div>

                        <div className='col-span-8 md:col-span-5 flex flex-col sm:flex-row sm:justify-center sm:space-x-20 mx-auto sm:mx-0'>
                            <div data-aos="fade-right" className='flex items-center space-x-5'>
                                <span className='text-2xl sm:text-6xl text-white'>5</span>
                                <span className='uppercase text-slate-300 text-xs sm:text-sm'>Years <br />Of Experience</span>
                            </div>
                            <div data-aos="fade-left" className='flex items-center space-x-5'>
                                <span className='text-2xl sm:text-6xl text-white'>100+</span>
                                <span className='uppercase text-slate-300 text-xs sm:text-sm'>Project Completed</span>
                            </div>
                        </div>

                        <div className="col-span-8"></div>

                    </div>

                </div>
                <div className="w-3/5 h-1 bg-gradient-to-r from-neutral-content z-50 -mt-[74px]"></div>


                {/* Put this part before </body> tag RESUME MODAL*/}
                <input type="checkbox" id="my-modal-5" className="modal-toggle" />
                <div className="modal">
                    <div className="modal-box w-full md:w-11/12 md:max-w-2xl">
                        <h3 className="font-bold text-lg">Resume of Anis Ayser</h3>
                        
                        <img src={resume} className="" alt="" />
                        <div className="modal-action">
                            <label htmlFor="my-modal-5" className="btn">Close</label>
                        </div>
                    </div>
                </div>
                {/* Put this part before </body> tag RESUME MODAL*/}



            </div>
        </div>
    );
};

export default Banner;